<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="query['storageRoom.name']" placeholder="business.label.storageRoomName" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['location.roadway']" placeholder="business.label.roadway" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
      </template>
      <vxe-table ref="table" :data="data" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="storageRoom.name" title="business.label.storageRoom" width="200"/>
        <vxe-column field="location.roadway" title="business.label.roadway" width="100"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="location.mechanicalLocking" title="business.label.locking" width="70"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button v-if="!row.location.mechanicalLocking" content="button.lock" icon="vxe-icon-lock" status="danger" @click.stop="execute(row,true)"/>
            <vxe-button v-if="row.location.mechanicalLocking" content="button.unlock" icon="vxe-icon-unlock" status="success" @click.stop="execute(row,false)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>

<script>
import { findAll, save } from '@/api/Api'

export default {
  name: 'LockingRoadway',
  data() {
    return {
      loading: false,
      data: [],
      query: { 'storageRoom.name': '', 'location.roadway': '' },
      page: 1,
      size: 20,
      contentSize: 0
    }
  },
  activated() {
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      findAll('roadwayFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = { 'storageRoom.name': '', 'location.roadway': '' }
      this.refresh()
    },
    execute(row, locking) {
      this.loading = true
      save('roadwayPersister', { storageRoom: row.storageRoom, roadway: row.location.roadway, locking: locking }).then(res => {
        if (res.success) {
          this.fetch()
          this.$message.success(this.$t('message.operationSuccess'))
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>